import React from "react";

import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentPanelHeader from "../../../../components/layout/content/ContentPanelHeader";

import TextField from "../../../../components/input/textfield/TextField";
import Select from "../../../../components/input/select/Select";
import Button from "../../../../components/buttons/Button";

import "./AccountForm.css";

const GENDER_OPTIONS = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Non-binary", value: "non_binary" },
  { label: "Prefer not to say", value: "none" },
];

export const PersonalDetailsForm = ({
  profile,
  onChange,
  onSave,
  loading = false,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();

    if (!loading) onSave(event);
  };

  return (
    <ContentPanel>
      <ContentPanelHeader
        title="Personal Details"
        subTitle="Manage your personal information."
      />

      <form className="account-form" onSubmit={handleSubmit}>
        <div className="account-form__grid">
          <TextField
            name="firstName"
            label="First name"
            value={profile?.firstName || ""}
            onChange={onChange}
            autoComplete="given-name"
            required
          />

          <TextField
            name="lastName"
            label="Last name"
            value={profile?.lastName || ""}
            onChange={onChange}
            autoComplete="family-name"
            required
          />

          <TextField
            name="dob"
            type="month"
            label="Month / Year Born"
            value={profile?.dob || ""}
            onChange={onChange}
            required
          />

          <TextField
            name="nationality"
            label="Nationality"
            value={profile?.nationality || ""}
            onChange={onChange}
          />

          <Select
            name="gender"
            label="Gender"
            value={profile?.gender || "none"}
            onChange={onChange}
            items={GENDER_OPTIONS}
          />

          <TextField
            name="mobile"
            type="tel"
            label="Mobile number"
            value={profile?.mobile || ""}
            onChange={onChange}
            autoComplete="tel"
          />
        </div>

        <div className="account-form__group">
          <ContentPanelHeader title="Location" />

          <div className="account-form__grid">
            <TextField
              name="suburb"
              label="Suburb"
              value={profile?.suburb || ""}
              onChange={onChange}
            />

            <TextField
              name="state"
              label="State / Region"
              value={profile?.state || ""}
              onChange={onChange}
            />

            <TextField
              name="country"
              label="Country"
              value={profile?.country || ""}
              onChange={onChange}
              autoComplete="country-name"
              required
            />

            <TextField
              name="postcode"
              label="Postcode"
              value={profile?.postcode || ""}
              onChange={onChange}
              autoComplete="postal-code"
            />
          </div>
        </div>

        <div className="account-form__actions">
          <Button
            type="submit"
            value={loading ? "Saving..." : "Save changes"}
            variant="primary"
            disabled={loading}
            style={{ width: "fit-content" }}
          />
        </div>
      </form>
    </ContentPanel>
  );
};

export const SecurityForm = ({
  profile,
  password,
  setPassword,
  onSave,
  loading = false,
}) => {
  const validPassword = typeof password === "string" && password.length >= 8;

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!loading && validPassword) {
      onSave(event);
    }
  };

  return (
    <ContentPanel>
      <ContentPanelHeader
        title="Security"
        subTitle="Manage your account security and password."
      />

      <form className="account-form" onSubmit={handleSubmit}>
        <div className="account-form__grid">
          <TextField
            name="email"
            type="email"
            label="Email address"
            value={profile?.email || ""}
            autoComplete="email"
            disabled
          />

          <TextField
            name="newPassword"
            type="password"
            label="New password"
            value={password || ""}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="At least 8 characters"
            autoComplete="new-password"
            showPasswordOption
            minLength={8}
            required
          />
        </div>

        <div className="account-form__actions">
          <Button
            type="submit"
            value={loading ? "Saving..." : "Update password"}
            variant="primary"
            disabled={loading || !validPassword}
            style={{ width: "fit-content" }}
          />
        </div>
      </form>
    </ContentPanel>
  );
};

export const DangerZoneForm = ({ onDelete, loading = false }) => {
  return (
    <ContentPanel>
      <ContentPanelHeader
        title="Danger Zone"
        subTitle="Permanently delete your account."
      />

      <div className="account-form">
        <p className="account-form__danger-description">
          Deleting your account will permanently remove your account and
          associated data from Katch. This action cannot be undone.
        </p>

        <div className="account-form__actions">
          <Button
            type="button"
            value={loading ? "Deleting..." : "Delete account"}
            variant="danger"
            onClick={onDelete}
            disabled={loading}
            style={{ width: "fit-content" }}
          />
        </div>
      </div>
    </ContentPanel>
  );
};
